import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { bookSchema, BookFormValues } from "@modules/books/validations/bookSchema";
import { useCreateBookMutation } from "@modules/books/services/mutations";

export function useBookCreateForm() {
  const { mutateAsync, isPending } = useCreateBookMutation();

  const methods = useForm<BookFormValues>({
    resolver: zodResolver(bookSchema),
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
